import { Injectable, inject } from '@angular/core';
import {
    IRelatedProductsCallback,
    IRelatedProductsOptions,
    RelatedProductsService
} from '@df/catalog-ui/related-products/related-products.service';
import { IProductDataV3, Product } from '@df/catalog/product/product';
import { ProductResource } from '@df/catalog/product/product.resource';
import { KlevuSearchService } from '@df/module-klevu-search/klevu-search.service';
import { KlevuSearch } from './klevu-interfaces';

@Injectable({
    providedIn: 'root'
})
export class KlevuContextRecommendationsBasketEngine {
    private klevuSearchService = inject(KlevuSearchService);

    private productResource = inject(ProductResource);

    private cache: { [context: string]: number[] } = {};

    async get(
        _ids: number[],
        callback: IRelatedProductsCallback,
        engineOptions: KlevuSearch.IContextRecommendationsOptions,
        _options: IRelatedProductsOptions
    ): Promise<void> {
        const cKey = ['basketRec', _ids.sort((a, b) => a - b), engineOptions.strategyId].join();
        try {
            if (!this.cache[cKey]) {
                this.cache[cKey] = await this.load(engineOptions, _ids);
            }
            callback(this.cache[cKey]);
        } catch (err) {
            callback([]);
        }
    }

    private async load(engineOptions: KlevuSearch.IContextRecommendationsOptions, _ids?: number[]): Promise<number[]> {
        const strategyId = engineOptions?.strategyId;
        if (strategyId) {
            const ids = _ids
                ? this.productResource
                      .getAllExisting(_ids, 3)
                      .map(product => this.klevuSearchService.getKlevuProductId(product as Product<IProductDataV3>))
                : [];
            return this.klevuSearchService.loadContextRecommendationsForBasket(strategyId, ids);
        }

        return [];
    }
}

RelatedProductsService.registerEngine(KlevuSearch.contextRecommendationsBasketEngineId, KlevuContextRecommendationsBasketEngine);
